import twclsx from 'utils/twclsx';

const baseClasses = 'inline-flex items-center text-body-mobile-sm px-5 rounded-md text-black';

export const colorVariants = {
    xLight: 'bg-opacity-10',
    light: 'bg-opacity-30',
    medium: 'bg-opacity-50',
    dark: 'bg-opacity-100',
};

export const bgColors = {
    default: 'bg-mango',
    primary: 'bg-mango if:bg-beet',
    info: 'bg-info',
    success: 'bg-success',
    blueberry: 'bg-blueberry',
    error: 'bg-error',
    warning: 'bg-warning',
    kale: 'bg-kale',
    lime: 'bg-lime if:bg-strawberry',
    malt: 'bg-malt if:bg-oat',
    offWhite: 'bg-off-white',
    special: 'bg-kale if:bg-beet',
    grey: 'bg-grey-light',
    bestSeller: 'bg-[#C8E2F3]',
    new: 'bg-[#CFE5BD]',
    lastChance: 'bg-[#FAEAC0]',
    white: 'bg-white',
    shopNow: 'bg-[#E3EEE5] if:bg-strawberry',
    cranberry: 'bg-cranberry',
    plusMembership: 'bg-gradient-berry-blend',
};

const fontSizes = {
    default: 'text-body-mobile-sm',
    mobileXS: 'text-body-mobile-xs',
    mobileXXS: 'text-body-mobile-xxs leading-snug',
};

const DARK_BACKGROUNDS_REQUIRING_WHITE_TEXT = ['blueberry', 'cranberry', 'error', 'special', 'success'];

/**
 * @param {object} props
 * @param {keyof typeof bgColors} [props.bgColor='default'] - Background color variant
 * @param {boolean} [props.bold=true] - Whether to use bold font
 * @param {React.ReactNode} props.children - Content to display in the tag
 * @param {keyof typeof fontSizes} [props.fontSize='default'] - Font size variant
 * @param {boolean} [props.roundedFull=false] - Whether to use fully rounded corners
 * @param {keyof typeof colorVariants} [props.variant='light'] - Color opacity variant
 */
function Tag({
    bgColor = 'default',
    bold = true,
    children,
    fontSize = 'default',
    roundedFull = false,
    variant = 'light',
}) {
    const bgColorClasses = bgColors[bgColor];
    const fontSizeClasses = fontSizes[fontSize];
    const variantClasses = colorVariants[variant];

    return (
        <span
            className={twclsx(baseClasses, bgColorClasses, fontSizeClasses, variantClasses, {
                'text-white':
                    (DARK_BACKGROUNDS_REQUIRING_WHITE_TEXT.includes(bgColor) && variant === 'dark') ||
                    bgColor === 'plusMembership',
                'text-grey': bgColor === 'grey',
                'text-black if:text-white': bgColor === 'primary',
                'font-grotesk-bold': bold,
                'rounded-full': roundedFull,
            })}
        >
            {children}
        </span>
    );
}

export default Tag;
